/**
 * Partners — shareable /partners route → partner signup.
 *
 * Why this route exists:
 *   Recruiting flyers, print QR codes, and outreach kits benefit
 *   from a short memorable path like poopluckers.com/partners. The
 *   existing partner-signup path was the query-string URL
 *   /signup?role=provider — fine for in-app CTAs but awkward on
 *   printed material.
 *
 * Design decision (flagged in VERDICT):
 *   REDIRECT via `<Navigate />` instead of a direct-render that
 *   remounts the Signup form. This keeps signup logic single-
 *   sourced — there is exactly one Signup page and one mount
 *   site. The redirect uses `replace` so hitting /partners doesn't
 *   pollute the browser history stack.
 *
 * Interaction with the partner-first Signup default flip
 * (commit db7b255):
 *   After the partner-first flip, bare /signup already defaults
 *   to the provider role. This route explicitly appends
 *   `?role=provider` anyway so:
 *     1. The URL is self-documenting (a share preview / analytics
 *        event on /signup?role=provider is unambiguous)
 *     2. If the un-parametrized default ever changes back, this
 *        route continues to land on provider signup regardless
 *
 * /signup?role=provider continues to work byte-identically — this
 * page is additive.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default function Partners() {
  return <Navigate to="/signup?role=provider" replace />;
}
